import Account from './account.svg';
import ArrowCollapse from './arrow-collapse.svg';
import ArrowExpand from './arrow-expand.svg';
import ArrowRight from './arrow-right.svg';
import BestSellers from './best-sellers.svg';
import Bike from './bike.svg';
import Bus from './bus.svg';
import Calendar from './calendar.svg';
import Car from './car.svg';
import CaretDown from './caret-down.svg';
import CaretLeft from './caret-left.svg';
import CaretRight from './caret-right.svg';
import CaretUp from './caret-up.svg';
import Cart from './cart.svg';
import CartOutlined from './cart-outlined.svg';
import Chat from './chat.svg';
import Checkmark from './checkmark.svg';
import CheckmarkGreen from './checkmark-green.svg';
import CircleCheck from './circle-check.svg';
import Clock from './clock.svg';
import Close from './close.svg';
import DeliveryTruck from './delivery-truck.svg';
import Error from './error.svg';
import Exit from './exit.svg';
import Facebook from './facebook.svg';
import Filter from './filter.svg';
import Fire from './fire.svg';
import FireAnimate from './fire-animate.svg';
import Freeshipping from './freeshipping.svg';
import GeoDisabled from './geo-disabled.svg';
import GeoEnabled from './geo-enabled.svg';
import GiftCard from './giftcard.svg';
import Heart from './heart.svg';
import HeartFilled from './heart-filled.svg';
import HeartOutlined from './heart-outlined.svg';
import HelpOutline from './help-outline.svg';
import Help from './help.svg';
import Hide from './hide.svg';
import Info from './info.svg';
import Instagram from './instagram.svg';
import InteracLogo from './interacLogo.svg';
import KlarnaLogo from './klarnaLogo.svg';
import KlarnaLogoBlk from './klarnaLogoBlk.svg';
import LeftArrow from './left-arrow.svg';
import Lowstock from './lowstock.svg';
import LoyaltyPerk1 from './loyalty-perk-1.svg';
import LoyaltyPerk2 from './loyalty-perk-2.svg';
import LoyaltyPerk3 from './loyalty-perk-3.svg';
import LoyaltyTierOne from './loyalty-tier-1.svg';
import LoyaltyTierTwo from './loyalty-tier-2.svg';
import LoyaltyTierThree from './loyalty-tier-3.svg';
import Mail from './mail.svg';
import MapleLeaf from './maple-leaf.svg';
import MastercardLogo from './mastercardLogo.svg';
import MecGiftcardLogo from './mecGiftcardLogo.svg';
import MarketplaceMec from './marketplace-mec.svg';
import MarketplaceBag from './marketplace-bag.svg';
import MecLogo from './mec-logo.svg';
import MecLogoWhite from './mec-logo-white.svg';
import MecLogoOutline from './mec-logo-outline.svg';
import Menu from './menu.svg';
import Minus from './minus.svg';
import NewFacebookIcon from './new-facebook-icon.svg';
import NewInstagramIcon from './new-instagram-icon.svg';
import NewYoutubeIcon from './new-youtube-icon.svg';
import NewXIcon from './new-x-icon.svg';
import Package from './package.svg';
import NewSuccess from './new-success.svg';
import Phone from './phone.svg';
import PickupStore from './pickup-store.svg';
import Pinterest from './pinterest.svg';
import Play from './play.svg';
import Plus from './plus.svg';
import Pointer from './pointer.svg';
import Pricematch from './pricematch.svg';
import Refresh from './refresh.svg';
import Resize from './resize.svg';
import ReviewStarEmpty from './review-star-empty.svg';
import ReviewStarFull from './review-star-full.svg';
import ReviewStarHalf from './review-star-half.svg';
import RightArrow from './right-arrow.svg';
import Rsg from './rsg.svg';
import Ruler from './ruler.svg';
import Search from './search.svg';
import Settings from './settings.svg';
import Share from './share.svg';
import Show from './show.svg';
import Sort from './sort.svg';
import Sparkle from './sparkle.svg';
import Storepickup from './storepickup.svg';
import Stores from './stores.svg';
import Success from './success.svg';
import StoreInfo from './store-info.svg';
import Transit from './transit.svg';
import Twitter from './twitter.svg';
import Van from './van.svg';
import ValuePropsBox from './valueprops-box-2.svg';
import ValuePropsCheck from './valueprops-check-2.svg';
import ValuePropsMec from './valueprops-mec-2.svg';
import ValuePropsReturn from './valueprops-return-2.svg';
import ValuePropsTag from './valueprops-tag-2.svg';
import VideoPlay from './video-play.svg';
import VisaLogo from './visaLogo.svg';
import Walk from './walk.svg';
import Warning from './warning.svg';
import Youtube from './youtube.svg';
import ZoomIn from './zoom-in.svg';
import ZoomOut from './zoom-out.svg';

const icons = {
  account: Account,
  'arrow-collapse': ArrowCollapse,
  'arrow-expand': ArrowExpand,
  'arrow-right': ArrowRight,
  'best-sellers': BestSellers,
  bike: Bike,
  bus: Bus,
  calendar: Calendar,
  car: Car,
  'caret-down': CaretDown,
  'caret-left': CaretLeft,
  'caret-right': CaretRight,
  'caret-up': CaretUp,
  cart: Cart,
  'cart-outlined': CartOutlined,
  'circle-check': CircleCheck,
  chat: Chat,
  checkmark: Checkmark,
  'checkmark-green': CheckmarkGreen,
  clock: Clock,
  close: Close,
  'delivery-truck': DeliveryTruck,
  error: Error,
  exit: Exit,
  facebook: Facebook,
  filter: Filter,
  fire: Fire,
  'fire-animate': FireAnimate,
  freeshipping: Freeshipping,
  'geo-disabled': GeoDisabled,
  'geo-enabled': GeoEnabled,
  giftcard: GiftCard,
  heart: Heart,
  'heart-filled': HeartFilled,
  'heart-outlined': HeartOutlined,
  'help-outline': HelpOutline,
  help: Help,
  hide: Hide,
  info: Info,
  instagram: Instagram,
  interacLogo: InteracLogo,
  klarnaLogo: KlarnaLogo,
  klarnaLogoBlk: KlarnaLogoBlk,
  'left-arrow': LeftArrow,
  lowstock: Lowstock,
  'loyalty-perk-1': LoyaltyPerk1,
  'loyalty-perk-2': LoyaltyPerk2,
  'loyalty-perk-3': LoyaltyPerk3,
  'loyalty-tier-1': LoyaltyTierOne,
  'loyalty-tier-2': LoyaltyTierTwo,
  'loyalty-tier-3': LoyaltyTierThree,
  mail: Mail,
  'maple-leaf': MapleLeaf,
  mastercardLogo: MastercardLogo,
  mecGiftcardLogo: MecGiftcardLogo,
  mecLogo: MecLogo,
  marketplaceMec: MarketplaceMec,
  marketplaceBag: MarketplaceBag,
  mecLogoWhite: MecLogoWhite,
  mecLogoOutline: MecLogoOutline,
  menu: Menu,
  minus: Minus,
  'new-facebook-icon': NewFacebookIcon,
  'new-instagram-icon': NewInstagramIcon,
  'new-youtube-icon': NewYoutubeIcon,
  'new-x-icon': NewXIcon,
  package: Package,
  'new-success': NewSuccess,
  phone: Phone,
  'pickup-store': PickupStore,
  pinterest: Pinterest,
  play: Play,
  plus: Plus,
  pointer: Pointer,
  pricematch: Pricematch,
  refresh: Refresh,
  resize: Resize,
  'review-star-full': ReviewStarFull,
  'review-star-empty': ReviewStarEmpty,
  'review-star-half': ReviewStarHalf,
  'right-arrow': RightArrow,
  rsg: Rsg,
  ruler: Ruler,
  search: Search,
  settings: Settings,
  share: Share,
  show: Show,
  sort: Sort,
  sparkle: Sparkle,
  storepickup: Storepickup,
  stores: Stores,
  success: Success,
  'store-info': StoreInfo,
  transit: Transit,
  twitter: Twitter,
  valuepropsbox: ValuePropsBox,
  valuepropscheck: ValuePropsCheck,
  valuepropsmec: ValuePropsMec,
  valuepropsreturn: ValuePropsReturn,
  valuepropstag: ValuePropsTag,
  van: Van,
  'video-play': VideoPlay,
  visaLogo: VisaLogo,
  walk: Walk,
  warning: Warning,
  youtube: Youtube,
  'zoom-in': ZoomIn,
  'zoom-out': ZoomOut,
};

export default icons;
